import React, { useState, useEffect } from "react";
import Main from "../../components/Main";
import TabelaDinamica from "../../components/TabelaDinamica";
import MensagemSucesso from "../../components/MensagemSucesso";
import MensagemErro from "../../components/MensagemErro";
import styles from "./styles.module.css";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Paper,
  DialogContentText,
} from "@mui/material";

import Draggable from "react-draggable";
import CRUDPageHeader from "../../components/CRUDPageHeader";
import ContaProtheusForm from "src/forms/ContaProtheusForm";
import {
  atualizarContaProtheus,
  buscarContasProtheus,
  buscarContasProtheusPorTexto,
  cadastrarContaProtheus,
  deletarContaProtheus,
} from "../../services/api-conciliacao.service";

function PaperComponent(props) {
  return (
    <Draggable
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}

const ContaProtheus = () => {
  const [data, setData] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [editRowData, setEditRowData] = useState({});
  const [openSnackbarSucesso, setOpenSnackbarSucesso] = useState(false);
  const [openSnackbarErro, setOpenSnackbarErro] = useState(false);
  const [msg, setMsg] = useState("");
  const [openDialogExclusao, setOpenDialogExclusao] = useState(false);
  const [loading, setLoading] = useState(false);

  const columns = [
    {
      id: "id_conciliacao_conta_contabil",
      label: "ID",
      field: "id_conciliacao_conta_contabil",
    },
    { id: "conta_contabil", label: "Conta Contábil", field: "conta_contabil" },
    { id: "Descrição", label: "Descrição", field: "descricao" },
  ];

  useEffect(() => {
    handleAtualizar();
  }, []);

  const handleOpenModal = (rowData) => {
    const isLinha =
      rowData &&
      typeof rowData === "object" &&
      rowData.id_conciliacao_conta_contabil != null;
    setEditRowData(isLinha ? rowData : {});
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleAtualizar = async () => {
    setLoading(true);
    try {
      const response = await buscarContasProtheus();
      setData(response.contasContabil);
      setLoading(false);
    } catch (err) {
      if (err.response) {
        setMsg(err.response.data.mensagem);
        handleOpenSnackbarErro();
      } else {
        setMsg("Erro: Tente novamente!");
        handleOpenSnackbarErro();
      }
      setLoading(false);
    }
  };

  const handleSaveChanges = async (data) => {
    if (!editRowData.id_conciliacao_conta_contabil) {
      // Cadastra
      await cadastrarContaProtheus(data)
        .then(async (response) => {
          setMsg(response.data?.mensagem ?? response.mensagem);
          handleOpenSnackbarSucesso();
          handleAtualizar();
          handleCloseModal();
        })
        .catch((err) => {
          if (err.response) {
            setMsg(err.response.data.mensagem);
            handleOpenSnackbarErro();
          } else {
            setMsg("Erro: Tente novamente!");
            handleOpenSnackbarErro();
          }
        });
    } else {
      //Atualiza
      await atualizarContaProtheus(
        editRowData.id_conciliacao_conta_contabil,
        data
      )
        .then(async (response) => {
          setMsg(response.data?.mensagem ?? response.mensagem);
          handleOpenSnackbarSucesso();
          handleAtualizar();
          handleCloseModal();
        })
        .catch((err) => {
          if (err.response) {
            setMsg(err.response.data?.mensagem ?? err.response.mensagem);
            handleOpenSnackbarErro();
          } else {
            setMsg("Erro: Tente novamente!");
            handleOpenSnackbarErro();
          }
        });
    }
  };

  const handleDelete = async () => {
    await deletarContaProtheus(editRowData.id_conciliacao_conta_contabil)
      .then(async (response) => {
        setMsg(response.data?.mensagem ?? response.mensagem);
        // Buscar dados novamente para renderizar
        handleOpenSnackbarSucesso();
        handleAtualizar();
        handleCloseDialogExclusao();
      })
      .catch((err) => {
        if (err.response) {
          setMsg(err.response.data.mensagem);
          handleOpenSnackbarErro();
        } else {
          setMsg("Erro: Tente novamente!");
          handleOpenSnackbarErro();
        }
      });
  };

  const handleDebounceChange = async (event) => {
    try {
      const response = await buscarContasProtheusPorTexto(
        event.target.value.toUpperCase()
      );
      setData(response.contasContabil);
    } catch (err) {
      if (err.response) {
        if (err.response.status === 404) {
          setData([]);
        } else {
          setMsg(err.response.data.mensagem);
          handleOpenSnackbarErro();
        }
      } else {
        setMsg("Erro: Tente novamente!");
        handleOpenSnackbarErro();
      }
    }
  };

  const handleOpenSnackbarSucesso = () => {
    setOpenSnackbarSucesso(true);
  };

  const handleCloseSnackbarSucesso = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbarSucesso(false);
  };

  const handleOpenSnackbarErro = () => {
    setOpenSnackbarErro(true);
  };

  const handleCloseSnackbarErro = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbarErro(false);
  };

  const handleClickOpenDialogExclusao = (rowData) => {
    setEditRowData(rowData);
    setOpenDialogExclusao(true);
  };

  const handleCloseDialogExclusao = () => {
    setOpenDialogExclusao(false);
  };

  return (
    <div>
      <Main />

      <CRUDPageHeader
        headerIcon={
          <>
            <AccountBalanceWalletIcon />
          </>
        }
        headerTitle="Contas Protheus"
        modalButtonLabel={"Adicionar"}
        handleOpenModal={handleOpenModal}
        handleDebounceChange={handleDebounceChange}
      />

      <TabelaDinamica
        data={data}
        columns={columns}
        loading={loading}
        disableEdit
        onDeleteButtonClick={handleClickOpenDialogExclusao}
      />
      <Dialog
        open={openModal}
        onClose={handleCloseModal}
        fullWidth
        maxWidth="sm"
        PaperProps={{
          sx: { maxWidth: 480 },
        }}
      >
        <DialogTitle sx={{pb:0}}>
          <div className={styles.tituloPopupContainer}>
          <AccountBalanceWalletIcon sx={{fontSize: '30px'}} />
            <h1 className={styles.tituloPopup}>Conta Protheus</h1>
          </div>
        </DialogTitle>
        <DialogContent sx={{m:0, p:0}}>
          <ContaProtheusForm
            contaProtheusValues={Object.assign({}, editRowData)}
            onSubmit={handleSaveChanges}
            onClose={handleCloseModal}
          />
        </DialogContent>
      </Dialog>

      {/* Dialog de exclusão */}
      <Dialog
        open={openDialogExclusao}
        onClose={handleCloseDialogExclusao}
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
      >
        <DialogTitle
          className={styles.tituloExclusao}
          style={{ cursor: "move" }}
          id="draggable-dialog-title"
        >
          Atenção!
        </DialogTitle>
        <DialogContent>
          <DialogContentText className={styles.textoExclusao}>
            Você realmente deseja excluir a conta contábil{" "}
            {editRowData.conta_contabil}?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            className={styles.botaoPopupCancelarExclusao}
            autoFocus
            onClick={handleCloseDialogExclusao}
          >
            Cancelar
          </Button>
          <Button className={styles.botaoPopupExcluir} onClick={handleDelete}>
            Sim
          </Button>
        </DialogActions>
      </Dialog>

      <MensagemSucesso
        open={openSnackbarSucesso}
        handleClose={handleCloseSnackbarSucesso}
        msg={msg}
      />

      <MensagemErro
        open={openSnackbarErro}
        handleClose={handleCloseSnackbarErro}
        msg={msg}
      />
    </div>
  );
};

export default ContaProtheus;
